<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>
<!-- <lifedi-breadcrumb *ngIf="measure && !isHidden" [lastPath]="measure.MEASURE_NAME"></lifedi-breadcrumb> -->

<div *ngIf="consentDetail" class="container">
  <div class="row justify-content-center">
    <div class="col-12">
      <h1 class="lifedi-color text-center mt-3">
        {{ consentDetail.RESEARCH_NAME }}
      </h1>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <h3><b>รายละเอียดงานวิจัย</b></h3>
    </div>
    <div class="col-12 my-2">
      <div id="_content" [innerHtml]="consentDetail.RESEARCH_DETAIL"></div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <h3 class="text-left" style="font-weight: bold;">Consent</h3>
      <button *ngIf="consentDetail.RESEARCH_DOC" (click)="consentDoc(consentDetail.RESEARCH_DOC)"
        class="btn text-center document">
        เอกสารประกอบงานวิจัย
      </button>

      <div class="card p-3">
        <p class="m-3" style="text-indent: 30px;">
          {{ consentDetail.CONSENT }}
        </p>
      </div>
    </div>
  </div>


  <div class="row justify-content-center py-3">
    <lifedi-btn *ngIf="!consentDetail.IS_LOGIN" lable="เข้าสู่ระบบ เพื่อเข้าร่วมงานวิจัย" class="mr-3"
      customStyle="color:white; background-color: #414A6B; width: 100%;" (click)="openLogin()">
    </lifedi-btn>

    <button *ngIf="consentDetail.IS_LOGIN" class="btn btn-success mr-3" (click)="confirm(consentDetail.RESEARCH_ID, consentDetail.INVITER)"
      style="color: #FFF; width: 100px;"> ยินยอม
    </button>
    <button *ngIf="this.consentDetail.IS_LOGIN" class="btn btn-danger" (click)="close()"
      style="color: #FFF; width: 100px;">ไม่ยินยอม
    </button>
  </div>
</div>
